import React, { ReactElement, Suspense, useEffect, useState } from 'react';

import LoadingOverlay from 'atomic/loading-overlay';
import Modal from 'components/modal';
import Button from 'atomic/button/button';
import { useSelector } from '@ecommerce/nest-ssr/common';
import { CompanyInterface } from 'interfaces/company.interface';

const ADULT_INFORMATION_KEY = 'OpineoAdultConfirmation';

const CompanyViewRestricted: React.FC = (): ReactElement | null => {
    const company = useSelector((state: { company: CompanyInterface; }) => state.company);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setShowModal(Boolean(company.isRestricted) && sessionStorage.getItem(ADULT_INFORMATION_KEY) !== 'yes');
    }, [company.isRestricted]);

    if (!showModal) {
        return null;
    }

    const handleClick = (isConfirmed = true): void => {
        if (isConfirmed) {
            setShowModal(false);
            sessionStorage.setItem(ADULT_INFORMATION_KEY, 'yes');
        } else {
            document.location.assign('/');
        }
    };

    return (
        <Suspense fallback={<LoadingOverlay />}>
            <Modal
                showCloseIcon={false}
                center={true}
                isOpen={true}
                onClose={(): void => setShowModal(false)}
                shouldCloseOnOverlayClick={false}
                modalClassName="dialog-modal"
                overlayClassName="dialog-modal__overlay"
                useModalLayout={true}
                title="Treść przeznaczona dla osób pełnoletnich"
            >
                <div>
                    <p className="dialog-modal__paragraph">
                        Klikając przycisk &quot;TAK&quot; oświadczasz, że ukończyłeś 18 lat.
                    </p>
                    <div className="dialog-modal__footer">
                        <Button type="button" color="green" uppercase={true}
                            onClick={(): void => handleClick(true)}
                        >
                            Tak
                        </Button>
                        <Button type="button" color="white" uppercase={true}
                            onClick={(): void => handleClick(false)}
                        >
                            Nie
                        </Button>
                    </div>
                </div>
            </Modal>
        </Suspense>
    );
};

export default CompanyViewRestricted;
